import { ClipboardList, Layers, Radar, TrendingUp } from "lucide-react";
import { Reveal } from "./Reveal";

const BENEFITS = [
  { id: "centraliza", title: "Centraliza", text: "Toda la información operacional en un solo ecosistema.", Icon: Layers },
  { id: "registra", title: "Registra", text: "Mantén trazabilidad clara de cada proceso.", Icon: ClipboardList },
  { id: "detecta", title: "Detecta", text: "Identifica problemas antes de que escalen.", Icon: Radar },
  { id: "decide", title: "Decide", text: "Usa información real para mejorar la operación.", Icon: TrendingUp },
];

export const Value = () => (
  <section id="por-que-tupu" data-testid="value-section" className="bg-[#F3EBD7]/45 py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <h2 className="max-w-2xl text-4xl font-medium tracking-tight text-[#1F3D35] md:text-5xl" data-testid="value-title">
          Menos planillas. Más control.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {BENEFITS.map(({ id, title, text, Icon }, i) => (
          <Reveal key={id} delay={i * 0.1}>
            <div
              data-testid={`benefit-${id}`}
              className="group h-full rounded-2xl border border-[#1F3D35]/6 bg-white p-7 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(15,77,63,0.08)]"
            >
              <span className="mb-6 flex h-12 w-12 items-center justify-center rounded-xl bg-[#DCECCF] text-[#0F4D3F] transition-colors duration-300 group-hover:bg-[#C6F04A]">
                <Icon size={22} strokeWidth={1.9} />
              </span>
              <h3 className="text-xl font-semibold tracking-tight text-[#1F3D35]">{title}</h3>
              <p className="mt-2.5 text-sm font-light leading-relaxed text-[#1F3D35]/70">{text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
